<template>
  <div class="welcome">
    <DisplayText :screenProperties="screenProperties"></DisplayText>
  </div>

  <!--BUTTONS-->
  <div class="buttons" id="start-buttons">
    <QppButton :buttons="buttons"></QppButton>
  </div>

  <div v-if="eidButton" class="eid-button w3-hide">
    <QppButton :buttons="eidButton" :loaded="cardRead"></QppButton>
  </div>

</template>

<script>
import store from "@/store";
import helper from "@/services/helper";
import DisplayText from "@/components/common/DisplayText";
import QppButton from "@/components/common/QppButton";
import screenApiService from "@/services/screenApiService";
import zijdeRoute from "@/services/zijderoute"
import {mapState} from "vuex";

const toTranslate = ['cardNotFound','go']

export default {
  name: 'eid_start',
  components: {DisplayText, QppButton},
  data() {
    return {
      buttons: [],
      screenProperties: {},
      eidButton: [],
      cardRead: false,
      cardNotFound: '',
      startTime: new Date(),
      cardChecked: false,
      cardReadSuccess: false,
      go: ''
    }
  },
  computed: mapState(['toggleText']),
  watch: {
    toggleText(newValue) {
      if (store.state.languageId !== store.state.defaultLanguage.id && this.cardNotFound !== '') {
        if (newValue === true) {
          this.getTranslation(store.state.defaultLanguage.id, toTranslate);
        } else if (newValue === false) {
          this.getTranslation(store.state.languageId, toTranslate);
        }
      }
    }
  },
  mounted() {
    const app = this;
    app.getTranslation(store.state.languageId, toTranslate);
    console.log("start_eid screen mounted start")
    store.commit('showModal', false);
    store.state.checkForgottenEid = true; //to remind of not forgetting card
    this.screenProperties = store.state.currentScreenProperties;
    let buttons = store.state.currentScreenOptions;
    let eidButton = [buttons[0]];
    console.log(eidButton);
    this.eidButton = eidButton;
    console.log(buttons);
    buttons.shift();
    this.buttons = buttons;
    zijdeRoute.onLoad();
    this.cardChecked = false;
    setTimeout(() => {app.checkCard();},10000) //start 10s after the screen loads
    helper.sortByKey(this.buttons, 'sortOrder');
    if (document.readyState !== 'loading') {
      setTimeout(this.setlangAnimation, 50);
      setTimeout(this.addHandAnimation, 500);
    } else {
      document.addEventListener('DOMContentLoaded', function () {
        setTimeout(this.setlangAnimation, 50);
        setTimeout(this.addHandAnimation, 500);
      });
    }
  },
  beforeUnmount() {
    screenApiService.resetPopup();
    zijdeRoute.offLoad();
  },
  methods: {
    getTranslation(lang = store.state.languageId, keys) {
      let app = this;
      if (lang) {
        keys.forEach(function (key) {
          screenApiService.getTranslation(lang, 'fe.' + key).then(function (response) {
            app[key] = response.data;
          }).catch(function () {
            console.log("No translation found for fe." + key + " in language " + lang);
            app[key] = '-'
          })
        })
      }
    },
    setlangAnimation() {
      let firstButton = document.getElementsByClassName('lang-button');
      if (firstButton) {
        let newAnimation = firstButton[0].classList.contains('new-animation')
        let parentButton = firstButton[0].parentElement;
        parentButton.classList.add('language-animation');
        if (newAnimation) {
          parentButton.classList.add('new-animation');
        }
      }
    },
    addHandAnimation() {
      let startIcon = document.getElementsByClassName('start-button');
      const elem = document.createElement('i');
      if (startIcon) {
        let parentButton = startIcon[0].parentElement;
        elem.classList.add("fa", "fa-hand-point-right", 'fa-3x', 'text-color', "hand-pointer-start");
        if (parentButton)
          parentButton.prepend(elem)
      }
    },
    recheck() {
      console.log("recheck called");
      this.startTime = Date.now();
      this.cardChecked = false;
      this.checkCard();
      setTimeout(() => {
        console.log("timeout method called");
        if (this.cardChecked === false) {
          store.commit('showError', true);
          store.state.errorStatus = 'CHECK_CARD_FAILED';
        }
      }, 10000);
    },
    checkCard() {
      console.log("checkCard called");
        console.log("starting zijderoute checkCard");
        zijdeRoute.checkCard((msg) => {
          this.cardChecked = true;
          console.log("zijderoute return:");
          console.log(msg);
          if (msg.success === true) {
            let cardPresent = msg.message.CARD_PRESENT;
            if (cardPresent === true) {
              console.log("card present")
              this.cardReadSuccess = false;
              this.readCard();
              setTimeout(() => {
                if (this.cardReadSuccess === false) {
                  store.commit('showError', true);
                  store.state.errorStatus = 'READ_CARD_FAILED';
                }
              }, 10000);
            } else {
              console.log("card not present")
              this.checkCard()
            }
          } else {
            console.log("Problems with checking card present")
            store.commit('showError', true);
            store.state.errorStatus = 'CHECK_CARD_FAILED';
          }
        });
    },
    readCard() {
      // document.querySelector("button").disabled = true;
      zijdeRoute.readCard((msg) => {
        if (msg.success === true) {
          this.cardReadSuccess = true;
          this.log(msg);
          this.cardRead = true;
          this.cardNotFound = '';
          this.go = '';
        }
      });
    },

    log(message) {
      console.log("LOGGING ON KIOSK PAGE %o", message);
      store.commit('setVisitorData', message.message);
    }
  }
}
</script>
